import { enqueueSnackbar } from "notistack";
import { ServerAPIResponse, Vendor, VendorUser, SupplementaryRequestVendorEmail, AddSupplementaryRequestVendorEmailsDto, RefreshVendorsResponseDto, DurableFunctionInstanceResponse, DurableFunctionStatusResponse, InviteGuestUserResponseDto } from "../helpers/InterfacesServer";
import { showBackDrop, callServerAPI } from "../helpers/Utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AxiosError } from "axios";
const MySwal = withReactContent(Swal);

export const getAllVendors = async () => {
    return await new Promise<Vendor[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Vendors"));
        callServerAPI<ServerAPIResponse<Vendor[]>>('GET', '/api/get_vendors', null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.details)
            })
    })
}

export const getAllVendorUsers = async () => {
    return await new Promise<VendorUser[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Vendor Users"));
        callServerAPI<ServerAPIResponse<VendorUser[]>>('GET', '/api/get_vendor_users', null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.details)
            })
    })
}

export const getVendorInvitationsReport = async () => {
    return await new Promise<InviteGuestUserResponseDto[]>(async (resolve, reject) => {
        callServerAPI<ServerAPIResponse<InviteGuestUserResponseDto[]>>('GET', '/api/get_vendor_invitations_report', null, true)
            .then(response => {
                resolve(response.data.details)
            })
    })
}


export const getAllSupplementaryRequestVendorEmails = async () => {
    return await new Promise<SupplementaryRequestVendorEmail[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Supplementary Request Vendor Emails"));
        callServerAPI<ServerAPIResponse<SupplementaryRequestVendorEmail[]>>('GET', '/api/get_supplementary_vendor_emails', null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.details)
            })
    })
}

export async function addSupplementaryRequestVendorEmails(dto: AddSupplementaryRequestVendorEmailsDto,) {
    return await new Promise<SupplementaryRequestVendorEmail[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Uploading Supplementary Request Vendor Emails"));
        const formData = new FormData();
        formData.append("vendor_code", dto.VendorCode);
        dto.Emails.forEach(email => formData.append("emails", email));
        formData.append("company_letter_pdf", dto.CompanyLetterPdf);
        callServerAPI<ServerAPIResponse<SupplementaryRequestVendorEmail[]>>('POST', '/api/add_supplementary_vendor_emails', formData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(response.data.message ?? "Supplementary Request Vendor Emails Uploaded", { variant: 'success' });
                resolve(response.data.details)
            })
    })
}


export async function getSupplementaryRequestVendorEmailCompanyLetter(CompanyLetterPdfFileName: string) {
    return await new Promise<Blob>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("downloading Supplementary Request Vendor Email letter"));
        callServerAPI<Blob>('GET', '/api/get_supplementary_email_request_company_letter?company_letter_pdf_file_name=' + CompanyLetterPdfFileName, null, true, 'blob')
            .then(response => {
                window.open(URL.createObjectURL(response.data));
                MySwal.close();
                enqueueSnackbar("Company letter has been downloaded", { variant: 'success' });
                resolve(response.data)
            })
    })
}

export async function onboardPendingVendors(auth_code: string | null) {
    return await new Promise<RefreshVendorsResponseDto>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Onboarding pending Vendors and Vendor Users"));
        callServerAPI<ServerAPIResponse<RefreshVendorsResponseDto>>('POST', '/api/refresh_ngep_vendors_http_triggered?code=' + (auth_code ?? ""), null, false)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(response.data.message ?? "Pending Vendors and Vendor Users Onboarded", { variant: 'success' });
                resolve(response.data.details)
            })
            .catch(function (error: AxiosError<string>) {
                console.log(error);
                if (error?.response?.status === 404 && error?.response?.data?.toLowerCase()?.startsWith("no_auth_code|")) {
                    const url = error.response.data.replace("no_auth_code|", "").trim();
                    window.location.href = url;
                }
                else
                    reject(error)
            });
    })
}

export async function longRunningOnboardPendingVendors(auth_code: string | null) {
    return await new Promise<DurableFunctionInstanceResponse>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Onboarding pending Vendors and Vendor Users"));
        callServerAPI<DurableFunctionInstanceResponse>('POST', '/api/refresh_ngep_vendors_orchestrator?code=' + (auth_code ?? ""), null, false, 'json', false, false)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Pending Vendors and Vendor Users Onboarding commenced", { variant: 'success' });
                resolve(response.data)
            })
            .catch(function (error: AxiosError<string>) {
                console.log(error);
                if (error?.response?.status === 404 && error?.response?.data?.toLowerCase()?.startsWith("no_auth_code|")) {
                    const url = error.response.data.replace("no_auth_code|", "").trim();
                    window.location.href = url;
                }
                else
                    reject(error)
            });
    })
}

export async function getlongRunningDurableFunctionStatus<T>(url: string) {
    return await new Promise<DurableFunctionStatusResponse<T>>(async (resolve, reject) => {
        callServerAPI<DurableFunctionStatusResponse<T>>('GET', url, null, true, 'json', true)
            .then(response => {
                resolve(response.data)
            })
    })
}

